import React from 'react';
import { Routes, Route, Navigate, useParams } from 'react-router-dom';
import CRMDashboard from './crm/Dashboard';
import LeadTracker from './crm/LeadTracker';
import OpportunityFinder from './crm/OpportunityFinder';
import MyTasks from './crm/MyTasks';
import MISReports from './crm/MISReports';
import Companies from './crm/Companies';
import Contacts from './crm/Contacts';
import Consultants from './crm/Consultants';
import ProjectsPipeline from './crm/ProjectsPipeline';
import Competitors from './crm/Competitors';
import PQTracker from './crm/PQTracker';

// Tendering_30Sep2026: Enquiry Tracker / Enquiry Detail / SVR now render
// inside the Tendering tab layout (Estimation.jsx) so the tab bar stays
// visible. These routes only redirect old bookmarks/links onward.
function RedirectEnquiry({ suffix = '' }) {
  const { id } = useParams();
  return <Navigate to={`/app/estimation/enquiries/${id}${suffix}`} replace />;
}

export default function CRM() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/app/crm/dashboard" replace />} />
      <Route path="/dashboard" element={<CRMDashboard />} />
      <Route path="/companies" element={<Companies />} />
      <Route path="/contacts" element={<Contacts />} />
      <Route path="/consultants" element={<Consultants />} />
      <Route path="/leads" element={<LeadTracker />} />
      <Route path="/pipeline" element={<ProjectsPipeline />} />
      <Route path="/enquiries" element={<Navigate to="/app/estimation/enquiries" replace />} />
      <Route path="/enquiries/new" element={<Navigate to="/app/estimation/enquiries/new" replace />} />
      <Route path="/enquiries/:id" element={<RedirectEnquiry />} />
      <Route path="/enquiries/:id/svr" element={<RedirectEnquiry suffix="/svr" />} />
      <Route path="/opportunity-finder" element={<OpportunityFinder />} />
      <Route path="/competitors" element={<Competitors />} />
      <Route path="/tasks" element={<Navigate to="/app/my-tasks" replace />} />
      <Route path="/reports" element={<MISReports />} />
      {/* BD_Emergent_Prompt_19Sep2026.md A1 — PQ Tracker restored (scoped: deadlines/reminders only, no vault) */}
      <Route path="/pq-tracker" element={<PQTracker />} />
      {/* Removed: PQ Vault, Document Repository — hard-deleted */}
      <Route path="/prequalification" element={<Navigate to="/app/crm/pq-tracker" replace />} />
      <Route path="/documents" element={<Navigate to="/app/crm/dashboard" replace />} />
      {/* Legacy redirects */}
      <Route path="/deals" element={<Navigate to="/app/crm/pipeline" replace />} />
      <Route path="/opportunities" element={<Navigate to="/app/crm/pipeline?view=list" replace />} />
      <Route path="/projects" element={<Navigate to="/app/crm/pipeline" replace />} />
      <Route path="/reminders" element={<Navigate to="/app/my-tasks" replace />} />
      <Route path="/communications" element={<Navigate to="/app/crm/dashboard" replace />} />
    </Routes>
  );
}
